import { render, staticRenderFns } from "./DropdownList.vue?vue&type=template&id=bd691b8a&"
import script from "./DropdownList.vue?vue&type=script&lang=js&"
export * from "./DropdownList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports